import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { pickNextFunItem } from "../data/funfacts";

// Kid-safe facts + silly jokes. The rotation picks from a 200-item pool and
// never repeats within a session — see `pickNextFunItem` in data/funfacts.js.
const FunFact = () => {
  const [item, setItem] = useState(() => pickNextFunItem());
  useEffect(() => { /* pick already ran on mount */ }, []);
  const roll = () => setItem(pickNextFunItem());

  return (
    <div
      className="chunky-card p-5 sm:p-6 flex items-start gap-4"
      style={{
        background:
          "linear-gradient(135deg, #FFE0F5 0%, #FFF9E6 60%, #E0F7FA 100%)",
      }}
      data-testid="fun-fact-card"
    >
      <div
        className="rounded-full flex items-center justify-center shrink-0"
        style={{
          width: 64,
          height: 64,
          background: "#FFB400",
          border: "3px solid #2b2b2b",
          boxShadow: "0 4px 0 #2b2b2b",
        }}
      >
        <span className="text-3xl bob" aria-hidden="true">
          {item.emoji}
        </span>
      </div>
      <div className="flex-1">
        <div
          className="chunky-badge mb-2"
          style={{
            background: item.kind === "joke" ? "#F368E0" : "#54D62C",
            color: "#2b2b2b",
          }}
        >
          {item.kind === "joke" ? "😆 Silly joke" : "💡 Did you know?"}
        </div>
        <p className="text-base sm:text-lg leading-snug" data-testid="fun-fact-text">
          {item.text}
        </p>
      </div>
      <button
        onClick={roll}
        className="btn-3d btn-sm btn-ghost shrink-0"
        aria-label="Show another"
        data-testid="fun-fact-next"
      >
        <RefreshCw size={16} strokeWidth={3} />
      </button>
    </div>
  );
};

export default FunFact;
